const BaseModule = require('../../90_utils/base/BaseModule');
const ScrollStepListener = require('../../90_utils/ScrollStepListener');

class Hero extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$window = $(window);
		this.$innerWrapper = this.$el.find('.inner-wrapper');
		this.scrollStepListener;
		this.scrollDelay;

		this.stepIndex = 0;
		this.hasFrameText = false;

		this.isFirstIntro = true;
		this.isFooterHero = this.$el.hasClass('footer-hero');
		this.isInFramedText = false;
		this.isInSteps = false;
		this.isMobile = false;
		this.isModalOpen = false;
		this.isPageLoaded = false;
		this.isPendingSection = false;
		this.isScrollLocked = true;

		this.status;

		this.$el.addClass('id' + (++window.SETTINGS.vars.svgIndex));

		this._checkScrollPos();
	}

	// private methods

	_domReady(){
		if(!this.$el.hasClass('is-hidden')){
			this.show();
		}
	}

	_addListeners(){

		if(!this.$el.hasClass('is-hidden')){

			this.$el.on('completeIntro', $.proxy(this._onCompleteIntro, this));
			this.$el.on('updateStatus', $.proxy(this._onUpdateStatus, this));

			this.$window.on('scroll', $.proxy(this._onScroll, this));
			this.$window.on('mousewheel', $.proxy(this._onMouseWheel, this));
			this.$el.find('.centered-quote a.title-link').on('click', $.proxy(this._onClick, this));
			this.$el.find('.mobile-continue').on('click', $.proxy(this._onClick, this));

			window.vent.on('pageLoadComplete', this._onPageLoadComplete, this);
			window.vent.on('pageChangeStart', this._onPageChangeStart, this);
			window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);
			window.vent.on('modalOpen', this._onModalOpen, this);
			window.vent.on('modalClose', this._onModalClose, this);

			if(this.$el.find('[data-framed-text]').length){
				this.hasFrameText = true;
			}

			if(!this.isFooterHero){
				window.vent.on('triggerScrollStep', this._onTriggerScrollStep, this);
			}

			// if(!this.scrollStepListener){
			// 	this.scrollStepListener = new ScrollStepListener($('body'), {
			// 		$touchEl: this.$el,
			// 		onTriggerCallback: this._onScrollStep.bind(this),
			// 		onScrollCompleteCallback: this._onScrollComplete.bind(this)
			// 	});
			// }

			this._checkScrollPos();
		}
	}

	_removeListeners(){

		this.$el.off('completeIntro', $.proxy(this._onCompleteIntro, this));
		this.$el.off('updateStatus', $.proxy(this._onUpdateStatus, this));

		this.$window.off('scroll', $.proxy(this._onScroll, this));
		this.$window.off('mousewheel', $.proxy(this._onMouseWheel, this));
		this.$el.find('.centered-quote a').off('click', $.proxy(this._onClick, this));
		this.$el.find('.mobile-continue').off('click', $.proxy(this._onClick, this));

		window.vent.off('pageLoadComplete', this._onPageLoadComplete, this);
		window.vent.off('pageChangeStart', this._onPageChangeStart, this);
		window.vent.off('pageChangeComplete', this._onPageChangeComplete, this);
		window.vent.off('triggerScrollStep', this._onTriggerScrollStep, this);
		window.vent.off('modalOpen', this._onModalOpen, this);
		window.vent.off('modalClose', this._onModalClose, this);

		if(this.scrollStepListener){
			this.hasFrameText = false;
			this.scrollStepListener.destroy();
			this.scrollStepListener = null;
		}
	}

	//

	_onScroll(e){
		this._checkScrollPos();

		if(this.scrollDelay){ window.clearTimeout(this.scrollDelay); }
		this.scrollDelay = window.setTimeout(() => {
			window.clearTimeout(this.scrollDelay);
			this.scrollDelay = null;
			this._onScrollStep(0);
		}, 500);
	}

	_onMouseWheel(e){
		this._checkScrollPos(e);
		if(this.isScrollLocked && this.isPageLoaded && !this.isMobile){
			e.preventDefault();
		}
	}

	_onClick(e){

		e.preventDefault();

		let $target = $(e.currentTarget);
		let href = $target.attr('data-href');

		this._changeRoute({route: href});
	}

	_onPageLoadComplete(){
		this.isPageLoaded = true;
	}

	_onPageChangeStart(){
		this.isScrollLocked = true;
	}

	_onPageChangeComplete(){
		this._killScrollLock();
	}

	_onTriggerScrollStep(e, params){
		this._onScrollStep(params.delta);
	}

	_onModalOpen(){
		this.isModalOpen = true;
	}

	_onModalClose(){
		this.isModalOpen = false;
	}

	_onCompleteIntro(){
		this._completeIntro();
		this._addScrollLock(1400);
	}

	_onUpdateStatus(){
		this._updateStatus();
	}

	//

	_onScrollStep(delta){

		let docHeight = window.SETTINGS.coords.getDocHeight();
		let winHeight = window.SETTINGS.coords.winHeight;
		let triggerLeeway = 40;

		// console.log('isInSteps', this.isInSteps, '!isScrollLocked', !this.isScrollLocked, '!isMobile', !this.isMobile, '!isModalOpen', !this.isModalOpen, 'isFooterHero', this.isFooterHero, 'delta', delta, );

		if(this.isInSteps && !this.isScrollLocked && !this.isMobile && !this.isModalOpen){

			let willScroll = false;
			let willDelay = false;
			let scrollLockDelay = 1400;
			let scrollPos = 0;

			// extra winHeight of buffer room in there for magic mice (stupid)

			if(this.hasFrameText && !this.isFooterHero){

				if(delta >= 0){
					if(this.scrollTop < winHeight){
						scrollPos = winHeight;
						willScroll = true;
					}
					else {
						willScroll = false;
					}
				}
				else {
					if(this.scrollTop <= winHeight){
						scrollPos = 0;
						willScroll = true;
						this.isInFramedText = false;
					}
					else if(this.scrollTop > winHeight && this.scrollTop < winHeight * 1.67) {
						scrollPos = winHeight;
						willScroll = true;
					}
				}
			}
			else if(this.isFooterHero) {

				if(delta >= 0){
					if(this.scrollTop > docHeight - winHeight * 2){

						if(this.isPendingSection && this.scrollTop >= docHeight - winHeight - triggerLeeway){
							// console.log('_onScrollStep CHANGE ROUTE', this.$el.attr('data-section-link'));
							this._changeRoute({route: this.$el.attr('data-section-link')});
							willScroll = false;
							willDelay = true;
						}
						else if(this.scrollTop >= docHeight - winHeight / 4 * 6){
							this.isPendingSection = true;
							willScroll = true;
							scrollPos = docHeight - winHeight; // - $('#main-footer').outerHeight();
						}
					}
				}
				else {
					willScroll = false;
					this.isPendingSection = false;
				}
			}
			else {
				willScroll = false;
			}

			if(willScroll){
				// console.log('willScroll', scrollPos);
				this._addScrollLock(scrollLockDelay);
				window.vent.trigger('scrollTo', {scrollTop: scrollPos});
			}
			else if(willDelay){
				this._addScrollLock(scrollLockDelay);
			}
		}

		this._checkScrollPos();
	}

	_onScrollComplete(delta){
		if(!this.isPendingSection){
			this._onScrollStep(delta);
		}
	}

	//

	_changeRoute(params){
		if(params){
			// console.log('HERO _changeRoute', params);
			window.vent.trigger('heroChangeRoute', params);
			window.vent.trigger('changeRoute', params);
		}
	}

	//

	_checkScrollPos(){

		let docHeight = window.SETTINGS.coords.getDocHeight();
		let winHeight = window.SETTINGS.coords.winHeight;
		let wasInSteps = this.isInSteps;
		let lastScrollPos = this.scrollTop;

		this.scrollTop = Math.round(this.$window.scrollTop());

		if(this.isMobile){
			this.$innerWrapper.removeClass('is-fixed is-bottomed');
			this.isInSteps = false;
		}
		else if(!this.isFirstIntro && !this.isModalOpen) {

			let delta = this.scrollTop - lastScrollPos;

			if(this.hasFrameText && !this.isFooterHero){

				if(this.scrollTop <= winHeight * 2){
					this.isInSteps = true;
					if(this.scrollTop < winHeight/2 && this.status !== 'intro' && delta <= 0){
						this._showIntro();
					}
					else if(this.scrollTop >= winHeight/2 && this.status !== 'framed-text' && delta > 0){
						this._showFramedText();
					}
				}
				else {
					this.isInSteps = false;
				}

				if(this.scrollTop <= winHeight * 3){

					if(this.scrollTop <= winHeight){
						this.$innerWrapper.addClass('is-fixed');
						this.$innerWrapper.removeClass('is-bottomed');
					}
					else {
						this.$innerWrapper.removeClass('is-fixed');
						this.$innerWrapper.addClass('is-bottomed');
					}
				}
				else {
					this.$innerWrapper.removeClass('is-fixed');
					this.$innerWrapper.addClass('is-bottomed');
				}
			}
			else if(this.isFooterHero) {

				if(this.scrollTop > docHeight - winHeight * 3){

					this.isInSteps = true;

					if(this.scrollTop >= docHeight - winHeight/4 * 5 && this.status !== 'half-intro' && delta > 0){
						this._halfIntro();
					}
					else if(this.scrollTop < docHeight - winHeight/2 * 3 && this.status !== 'half-intro-return' && delta < 0){
						this._halfIntroReturn();
					}
				}
				else {
					this.isInSteps = false;
				}
			}

			this.$el.addClass('is-scroll-set');
		}
	}

	// add / remove scroll lock

	_addScrollLock(delay){

		delay = delay || 1000;

		this._killScrollLock();
		this.isScrollLocked = true;

		this.scrollLock = window.setTimeout(() => {
			this.isScrollLocked = false;
		}, delay);
	}

	_killScrollLock(){
		if(this.scrollLock){
			window.clearTimeout(this.scrollLock);
			this.scrollLock = null;
		}
		this.isScrollLocked = false;
	}

	//

	_showFramedText(){

		if(this.status !== 'framed-text' && !this.isInFramedText){

			let $introContent = this.$innerWrapper.find('>.content');
			let $quote = this.$innerWrapper.find('.centered-quote');
			let $polyWrapper = this.$innerWrapper.find('.poly-wrapper');
			let $bg = this.$innerWrapper.find('.hero-bg');

			let $framedText = this.$innerWrapper.find('>.content-block--framed-text');
			let $framedQuote = $framedText.find('.text-content');

			TweenMax.killTweensOf([$introContent, $quote, $polyWrapper, $bg, $framedText, $framedQuote]);

			if(!this.isInFramedText){
				TweenMax.set($framedText, {opacity:1});
				TweenMax.to($quote, 0.6, {opacity:0, y:-30, ease:'fade'});
				TweenMax.fromTo($framedQuote, 0.4, {opacity:0, y:30}, {opacity:1, y:0, delay:0.3, ease:'fade'});
				TweenMax.to([$introContent, $polyWrapper, $bg], 0.6, {opacity:0, ease:'longFade', onComplete:() => {
					$framedText.css('z-index', 8);
				}});
			}

			this.isInFramedText = true;
			this.status = 'framed-text';
		}
	}

	_showIntro(){

		console.log('_showIntro', this.status);

		if(this.status !== 'intro' && this.isInFramedText){

			let $introContent = this.$innerWrapper.find('>.content');
			let $quote = this.$innerWrapper.find('.centered-quote');
			let $polyWrapper = this.$innerWrapper.find('.poly-wrapper');
			let $bg = this.$innerWrapper.find('.hero-bg');

			let $framedText = this.$innerWrapper.find('>.content-block--framed-text');
			let $framedQuote = $framedText.find('.text-content');

			TweenMax.killTweensOf([$introContent, $quote, $polyWrapper, $bg, $framedText, $framedQuote]);

			TweenMax.set($framedText, {clearProps:'z-index'});
			TweenMax.to($framedQuote, 0.4, {opacity:0, y:30, ease:'fade'});
			TweenMax.to([$introContent, $polyWrapper, $bg], 0.3, {opacity:1, ease:'fade'});
			TweenMax.fromTo($quote, 0.6, {opacity:0, y:-30}, {opacity:1, y:0, delay:0.3, ease:'fade'});

			this.isInFramedText = false;
			this.status = 'intro';
		}
	}

	//

	_fullIntro(){

		console.log('_fullIntro', this.status);

		if(this.status !== 'intro'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			let delay = 0.6;

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.fromTo($quote, 0.6, {opacity:0, y:10}, {opacity:1, y:0, delay:delay + 0.4, ease:'fade'});
			TweenMax.fromTo($polyWrapper, 1.2, {opacity:0, visibility:'visible'}, {opacity:1, delay:delay, ease:'longFade', onStart:() => {
				this.$el.addClass('is-in');
			},
			onComplete:() => {
				window.vent.trigger('heroIntroComplete', {$el: this.$el});
			}});

			this.status = 'intro';
		}
		else {
			window.setTimeout(() => {
				window.vent.trigger('heroIntroComplete', {$el: this.$el});
			}, 500);
		}
	}

	_halfIntro(){

		if(this.status !== 'half-intro'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			let delay = 0.3;

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.to($quote, 0.6, {opacity:1, y:0, delay:delay + 0.2, ease:'fade'});
			TweenMax.fromTo($polyWrapper, 1.0, {opacity:0, visibility:'visible'}, {opacity:1, delay:delay + 0.0, ease:'longFade'});

			this.status = 'half-intro';
		}
	}

	_halfIntroReturn(){

		if(this.status !== 'half-intro-return'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.to($quote, 0.6, {opacity:0, ease:'fade', onComplete: () => {
				TweenMax.set($quote, {y:20});
			}});
			TweenMax.to($polyWrapper, 1.2, {opacity:0, ease:'longFade'});

			this.status = 'half-intro-return';
		}
	}

	_completeIntro(){

		if(this.status !== 'intro'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			this._instantHalf();

			window.SETTINGS.animationFrame.one(() => {

				this._instantIntro();

				window.setTimeout(() => {
					window.vent.trigger('heroIntroComplete', {$el: this.$el});
				}, 500);
			});

			this.status = 'intro';
		}
		else {
			window.setTimeout(() => {
				window.vent.trigger('heroIntroComplete', {$el: this.$el});
			}, 500);
		}
	}

	_instantHalf(){

		if(this.status !== 'half-intro'){

			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.set($quote, {opacity:1, y:0});
			TweenMax.set($polyWrapper, {opacity:0.5});

			this.status = 'half-intro';
		}
	}

	_instantIntro(){

		if(this.status !== 'intro'){

			let $introContent = this.$innerWrapper.find('>.content');
			let $quote = this.$el.find('.centered-quote');
			let $polyWrapper = this.$el.find('.poly-wrapper');
			let $bg = this.$el.find('.hero-bg');

			TweenMax.killTweensOf([$quote, $polyWrapper]);
			TweenMax.set([$introContent, $bg, $quote], {opacity:1, y:0});

			if($polyWrapper.length){
				TweenMax.set($polyWrapper, {opacity:1, visibility:'visible'});
			}
			else {
				TweenMax.set($polyWrapper, {opacity:0.5});
			}

			this.status = 'intro';
		}
	}

	//

	_show(){

		this.$el.addClass('is-showing');

		if(!this.isFooterHero && !this.$el.hasClass('is-hidden')){
			if($('#page-content-controller').hasClass('is-scroll-swap')){
				this._completeIntro();
				this._addScrollLock(1400);
			}
			else {
				this._fullIntro();
				this._addScrollLock(2000);
			}
		}

		this.isFirstIntro = false;
	}

	_hide(){
		this.$el.removeClass('is-showing');
	}

	// update footer status

	_updateStatus(){
		this.isFooterHero = this.$el.hasClass('footer-hero');
		this._removeListeners();
		this._addListeners();
	}

	//

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		let wasMobile = this.isMobile;

		if(window.SETTINGS.breakpoint.minWidth('screen-medium')){
			this.isMobile = false;
			if(wasMobile === true){
				this._instantIntro();
			}
		}
		else {
			this.isMobile = true;
			if(wasMobile === false){ // could be undefined, doesn't count
				this._instantIntro();
			}
		}

		this.$el.css('width', window.SETTINGS.coords.docWidth);
		this._checkScrollPos();
	}
}

module.exports = Hero;
